import React from "react";
import { useSelector } from "react-redux";
import ContactForm from "../ContactFormModal/ContactForm";
import KnowMore from "./KnowMore";
import "./styles.scss";

const AgentBusinessCardMini = ({
  withKnowMore,
  withForm,
  onContactAgent,
  onCancelForm,
  onSubmitForm,
}) => {
  const agentProfile = useSelector((store) => store.profile.agent);
  const settings = useSelector((store) => store.profile.settings);

  if (!agentProfile) return null;

  return (
    <div className="dyna-box agent-card-over">
      <div className="agent">
        <div className="photo-name">
          {agentProfile.AgentPhotoMiniUrl && (
            <div className="dyna-photo-width">
              <div
                className="dyna-bg-img-round"
                style={{
                  backgroundImage: `url(${agentProfile.AgentPhotoMiniUrl})`,
                }}
              />
            </div>
          )}
          <div className="agent-name">
            {!agentProfile.Team && (
              <div className="agent-name_header">
                {agentProfile.FirstName} {agentProfile.LastnName}
              </div>
            )}
            {agentProfile.Team && (
              <div className="agent-name_header">
                {agentProfile.Team.AssigneeName ? (
                  <div>
                    <div>{agentProfile.Team.AssigneeName}</div>
                    <div className="ft-wt-nl">On Behalf Of</div>
                    <div className="ft-wt-nl">
                      {agentProfile.Team.DisplayName}
                    </div>
                  </div>
                ) : (
                  agentProfile.Team.DisplayName
                )}
              </div>
            )}
            {agentProfile.DreNumber && (
              <div>
                {settings?.DRENumberDisplayName}: {agentProfile.DreNumber}
              </div>
            )}
          </div>
        </div>
        <div className="agent-info">
          {agentProfile.Email && (
            <div>
              Email:{" "}
              <a href={`mailto:${agentProfile.Email}`}>{agentProfile.Email}</a>
            </div>
          )}
          {agentProfile.OfficePhone && (
            <div>Office: {agentProfile.OfficePhone} </div>
          )}
          {agentProfile.CellPhone && (
            <div>Mobile: {agentProfile.CellPhone} </div>
          )}
        </div>
      </div>
      {(withKnowMore || withForm) && (
        <div className="form-container">
          {withKnowMore && (
            <KnowMore
              agentName={agentProfile.FirstName}
              onContactAgent={onContactAgent}
            />
          )}
          {withForm && (
            <ContactForm onCancel={onCancelForm} onSubmit={onSubmitForm} />
          )}
        </div>
      )}
    </div>
  );
};

export default AgentBusinessCardMini;
